import * as React from 'react';
import { Box, Card, Typography, LinearProgress, Button } from '@mui/material';
import { Target, Zap, ArrowUp, ArrowDown } from 'lucide-react';
import { Link } from 'react-router-dom';

const DesktopRightPanel: React.FC = () => {
    return (
        <Box sx={{ width: 320, display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Activity card with two quick links: Income & Spending Analysis */}
            <Card sx={{ p: 2, borderRadius: 2, bgcolor: 'primary.main', color: 'white' }}>
                <Typography variant="subtitle2" fontWeight="bold" mb={1} color="inherit">
                    Activity
                </Typography>
                <Typography variant="caption" mb={1} sx={{ color: 'rgba(255,255,255,0.85)' }}>
                    Quick insights — tap to view detailed analysis
                </Typography>

                <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
                    {/* Income Analysis mini-card (green) */}
                    <Card
                        component={Link}
                        to="/income-analysis"
                        sx={{
                            flex: 1,
                            minWidth: 140,
                            p: 1.25,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 0.5,
                            alignItems: 'flex-start',
                            textDecoration: 'none',
                            cursor: 'pointer',
                            bgcolor: 'success.main',
                            color: 'white',
                            '&:hover': { boxShadow: 6, transform: 'translateY(-2px)' },
                            transition: 'transform 150ms ease, box-shadow 150ms ease',
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <ArrowUp size={16} color="white" />
                            <Typography variant="body2" fontWeight="bold" color="inherit">
                                Income
                            </Typography>
                        </Box>
                        <Typography variant="caption" color="rgba(255,255,255,0.9)">
                            View income trends & breakdown
                        </Typography>
                    </Card>

                    {/* Spending Analysis mini-card (red) */}
                    <Card
                        component={Link}
                        to="/spending-analysis"
                        sx={{
                            flex: 1,
                            minWidth: 140,
                            p: 1.25,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 0.5,
                            alignItems: 'flex-start',
                            textDecoration: 'none',
                            cursor: 'pointer',
                            bgcolor: 'error.main',
                            color: 'white',
                            '&:hover': { boxShadow: 6, transform: 'translateY(-2px)' },
                            transition: 'transform 150ms ease, box-shadow 150ms ease',
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <ArrowDown size={16} color="white" />
                            <Typography variant="body2" fontWeight="bold" color="inherit">
                                Spending
                            </Typography>
                        </Box>
                        <Typography variant="caption" color="rgba(255,255,255,0.9)">
                            See spending categories & insights
                        </Typography>
                    </Card>
                </Box>
            </Card>

            {/* Savings Goal */}
            <Card sx={{ p: 2.5, borderRadius: 2 }}>
                <Typography variant="subtitle2" fontWeight="bold" mb={1}>
                    Savings Progress
                </Typography>
                <Typography variant="h6" color="success.main" mb={1}>
                    ₦450,000
                </Typography>
                <LinearProgress
                    variant="determinate"
                    value={75}
                    sx={{ height: 8, borderRadius: 4, mb: 1 }}
                />
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="caption">Current</Typography>
                    <Typography variant="caption" color="text.secondary">
                        ₦600,000 goal
                    </Typography>
                </Box>
            </Card>

            {/* Quick Actions */}
            <Card sx={{ p: 2.5, borderRadius: 2 }}>
                <Typography variant="subtitle2" fontWeight="bold" mb={1.5}>
                    Quick Actions
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<Zap size={16} />}
                        sx={{ justifyContent: 'flex-start' }}
                        component={Link}
                        to="/fund"
                    >
                        Fund Wallet
                    </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Target size={16} />}
                        sx={{ justifyContent: 'flex-start' }}
                        component={Link}
                        to="/goals"
                    >
                        Set Goal
                    </Button>
                </Box>
            </Card>

            {/* Recommendations */}
            <Card sx={{ p: 2.5, borderRadius: 2, bgcolor: '#f0e7ff' }}>
                <Typography variant="subtitle2" fontWeight="bold" mb={1} color="black">
                    💡 Tip
                </Typography>
                <Typography variant="body2" color="black">
                    Consistent recurring payments boost your credit score.
                </Typography>
            </Card>
        </Box>
    );
};

export default DesktopRightPanel;

